"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLocalizedGroupType = exports.processEmails = void 0;
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const translation_1 = require("./translation");
const processEmails = (ajax, getToken, input, baseUrl) => {
    const chunks = [];
    const invites = [...input];
    while (invites.length) {
        chunks.push(ajax({
            headers: {
                'Content-Type': 'application/json',
                Authorization: getToken()
            },
            method: 'POST',
            url: `${baseUrl}api/user-group/member`,
            body: invites.splice(0, 20)
        }));
    }
    return (0, rxjs_1.from)(chunks).pipe((0, operators_1.concatAll)());
};
exports.processEmails = processEmails;
const getLocalizedGroupType = (groupType, defaultValue) => {
    switch (groupType) {
        case 'ProjectAdminUserGroup':
            return (0, translation_1.getLocalization)('userfront/project/teamMembers/projectAdministrators');
        case 'SokoBidAdminUserGroup':
            return (0, translation_1.getLocalization)('userfront/project/teamMembers/sokobidAdministrators');
        case 'SokoBidCategoryUserGroup':
            return (0, translation_1.getLocalization)('userfront/project/teamMembers/sokobidUsers');
        case 'LightAdminCategoryUserGroup':
            return (0, translation_1.getLocalization)('userfront/project/teamMembers/lightAdmins');
        default:
            return defaultValue;
    }
};
exports.getLocalizedGroupType = getLocalizedGroupType;
//# sourceMappingURL=usergroups.js.map